import {
  FinishRecoveryRequest,
  RecoveryResponse,
  StartRecoveryRequest,
} from '../models/api';
import jsonApi from './json-api';

const API_SECTION = 'auth';

function startRecovery({ login }: StartRecoveryRequest): Promise<RecoveryResponse> {
  return jsonApi.post<StartRecoveryRequest, RecoveryResponse>(
    `${API_SECTION}/recovery/password/start`,
    {
      login,
    },
  );
}

function finishRecovery({
  token,
  password,
}: FinishRecoveryRequest): Promise<RecoveryResponse> {
  return jsonApi.post<FinishRecoveryRequest, RecoveryResponse>(
    `${API_SECTION}/recovery/password`,
    {
      token,
      password,
    },
  );
}

export { finishRecovery, startRecovery };
